import { Grid, Stack, Typography, Box } from "@mui/material";
import { useStoreContext } from "../..";
import dayjs from "dayjs";
import { translateNoteFieldAlias } from "../../utils/fieldHelpers";

const MyNotesDayList = ({ onClick }: { onClick: (day: any) => void }) => {
  const { measurementStore } = useStoreContext();

  if (!measurementStore.dayNotes) {
    return null;
  }

  const days = Array.from(measurementStore.dayNotes.keys());

  return (
    <>
      {days.map((item, index) => (
        <Grid
          container
          key={`${item}-${index}`}
          p={2}
          sx={{ borderBottom: "1px solid lightgrey" }}
          spacing={2}
        >
          <Grid item xs={12} sm={3}>
            <Stack direction="column">
              <Typography>{dayjs(item).format("YYYY-MM-DD")}</Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={9}>
            {(measurementStore.dayNotes?.get(item) || []).map((i, index) => (
              <Box key={index} className="flex-column-start-start">
                <Typography>
                  {translateNoteFieldAlias(i.fieldAlias)}: {i.value}
                </Typography>
              </Box>
            ))}
          </Grid>
        </Grid>
      ))}
    </>
  );
};

export default MyNotesDayList;
